import React, { useState } from 'react';
import Latest from '../Components/Latest';
import AI from '../img/research/AI.png'
import PM from '../img/research/PM.png'

const latestNews = [
 
    {
        title: "Completion of DL Research  ",
        date: "10 Dec 2022",
        paragraph: " I am happy to announced the status of current research.",
    },
    {
        title: "Completion of Meta Research",
        date: "4 Dec 2022",
        paragraph: "I am happy to announce that I have completed the meta research for Visual Question Answering (VQA) Systems.",
    },
    {
        title: "Research proposal has been finalized",
        date: "03 Oct 2022",
        paragraph: "The research proosal has been finalized on the topic 'Embodying a SMARTMedical Assistant' for 2023 research. ",
    }
]

const Research = () => {
    const [stop, setStop] = useState(true)
    const changeColor = () => {
        console.log(window.scrollY);
        if (window.scrollY >= 1800) {
            setStop(false)
        }
        else {
            setStop(true)
        }
    }
    window.addEventListener('scroll', changeColor)

    return (
        <div className=' xl:px-20 lg:py-5 p-5'>
            <div className='grid md:grid-cols-[75%_minmax(20%,_1fr)] gap-3'>
                <div>
                    <h2 className=' text-2xl lg:text-3xl text-slate-500 font-semibold mb-3 border-b-2 border-cyan-500'>ARTIFICIAL INTELLIGENCE</h2>
                    <img src={AI} alt="loading..." className='mx-auto md:h-[60vh] mt-5 w-[100%] ' />
                    <h2 className=' text-xl text-slate-400 font-semibold my-3'  >Neuro Symbolic Artificial Intelligence</h2>
                    <p>
                        Neuro-symbolic artificial intelligence is a novel area of AI research which seeks to combine traditional rules-based AI approaches with modern deep learning techniques. Neuro-symbolic models have already demonstrated the capability to outperform state-of-the-art deep learning models in domains such as image and video reasoning. They have also been shown to obtain high accuracy with significantly less training data than traditional models. Due to the recency of the field's emergence and relative sparsity of published results, the performance characteristics of these models are not well understood. In this paper, we describe and analyze the performance characteristics of three recent neuro-symbolic models. We find that symbolic models have less potential parallelism than traditional neural models due to complex control flow and low-operational-intensity operations, such as scalar multiplication and tensor addition. However, the neural aspect of computation dominates the symbolic part in cases where they are clearly separable. We also find that data movement poses a potential bottleneck, as it does in many ML workloads.
                    </p>
                    <p>
                        I am currently involded in the development of NSAI system that combines NLP models with existing gallery of knowledge.
                        To know more about this research, feel free to write me.
                    </p>

                    <h2 className=' text-xl mt-10 text-slate-400 font-semibold mb-3' > Unsuperwise ML & Clusting </h2>
                    <p>
                    </p>
                    Unsupervised learning, also known as unsupervised machine learning, uses machine learning algorithms to analyze and cluster unlabeled datasets. These algorithms discover hidden patterns or data groupings without the need for human intervention. Its ability to discover similarities and differences in information make it the ideal solution for exploratory data analysis, cross-selling strategies, customer segmentation, and image recognition.

                    <p>
                        To know more about this research, feel free to write me.
                    </p>


                    <h2 className=' text-2xl lg:text-3xl mt-10 text-slate-500 font-semibold mb-3 border-b-2 border-cyan-500'>PROJECT MANAGEMENT</h2>
                    <img src={PM} alt="loading..." className='mx-auto md:h-[60vh] mt-5 w-[100%]' />
                    <h2 className=' text-xl text-slate-400 font-semibold my-3'  >PM Strategy in Small cap Organization </h2>
                    <p>
                        Neuro-symbolic artificial intelligence is a novel area of AI research which seeks to combine traditional rules-based AI approaches with modern deep learning techniques. Neuro-symbolic models have already demonstrated the capability to outperform state-of-the-art deep learning models in domains such as image and video reasoning. They have also been shown to obtain high accuracy with significantly less training data than traditional models. Due to the recency of the field's emergence and relative sparsity of published results, the performance characteristics of these models are not well understood. In this paper, we describe and analyze the performance characteristics of three recent neuro-symbolic models. We find that symbolic models have less potential parallelism than traditional neural models due to complex control flow and low-operational-intensity operations, such as scalar multiplication and tensor addition. However, the neural aspect of computation dominates the symbolic part in cases where they are clearly separable. We also find that data movement poses a potential bottleneck, as it does in many ML workloads.
                    </p>
                    <p>
                        To know more about this research, feel free to write me.
                    </p>

                    <h2 className=' text-xl mt-10 text-slate-400 font-semibold mb-3'> Human Resource Procurement & Management </h2>
                    <p>
                        Neuro-symbolic artificial intelligence is a novel area of AI research which seeks to combine traditional rules-based AI approaches with modern deep learning techniques. Neuro-symbolic models have already demonstrated the capability to outperform state-of-the-art deep learning models in domains such as image and video reasoning. They have also been shown to obtain high accuracy with significantly less training data than traditional models. Due to the recency of the field's emergence and relative sparsity of published results, the performance characteristics of these models are not well understood. In this paper, we describe and analyze the performance characteristics of three recent neuro-symbolic models. We find that symbolic models have less potential parallelism than traditional neural models due to complex control flow and low-operational-intensity operations, such as scalar multiplication and tensor addition. However, the neural aspect of computation dominates the symbolic part in cases where they are clearly separable. We also find that data movement poses a potential bottleneck, as it does in many ML workloads.
                    </p>
                    <p>
                        To know more about this research, feel free to write me.
                    </p>

                </div>
                <div className={`${stop && ' fixed right-[5%] h-[100vh] w-[21%] max-[1022px]:top-[15%]'}`}>
                    <Latest btn='More' latestNews={latestNews}></Latest>
                </div>
            </div>

        </div>


    );
};

export default Research;
